import Interceptor from "./Interceptor";

export const enableMonitoring = async (siteId, durationMin = 5) => {
  const response = await Interceptor.post(
    `/monitoring/sites/${siteId}/enable`,
    {
      durationMin,
    },
  );
  return response.data;
};

export const disableMonitoring = async (siteId) => {
  const response = await Interceptor.post(
    `/monitoring/sites/${siteId}/disable`,
  );
  return response.data;
};

export const getMonitoringStatus = async (siteId) => {
  const response = await Interceptor.get(`/monitoring/sites/${siteId}/status`);
  return response.data;
};

export const listTraces = async (siteId, params = {}) => {
  const response = await Interceptor.get(`/monitoring/sites/${siteId}/traces`, {
    params,
  });
  return response.data;
};

export const getTrace = async (siteId, traceId) => {
  const response = await Interceptor.get(
    `/monitoring/sites/${siteId}/traces/${traceId}`,
  );
  return response.data;
};

export const clearTraces = async (siteId) => {
  const response = await Interceptor.delete(
    `/monitoring/sites/${siteId}/traces`,
  );
  return response.data;
};
